import React from 'react';

import BgImg from './Background.png';

import styles from './Background.module.css';

const Background = () => {
  return  <img src={BgImg} className={styles.bgimage} />
}

export default Background;